namespace $.$$ {

	$mol_style_define( $shm_hitalama_opencode_map_sessions, {

		Content: {
			flexDirection: 'column',
			gap: $mol_gap.text,
			padding: $mol_gap.block,
			minWidth: '18rem',
			maxWidth: '26rem',
		},

		New_session: {
			justify: {
				content: 'flex-start',
			},
		},

		Sessions: {
			maxHeight: '18rem',
			overflow: 'auto',
		},

		Session_row: {
			justify: {
				content: 'flex-start',
			},
			'[selected]': {
				true: {
					color: $mol_theme.current,
					textShadow: '0 0',
				},
			},
		},

	} )

}
